// SYN-2738 (U13) — "Manter conectado": the JWT lives in localStorage when the
// person asked to stay signed in, in sessionStorage (gone when the browser
// closes) otherwise. Every reader goes through `getStoredToken`, which checks
// both. / O token fica no localStorage com "Manter conectado" marcado e no
// sessionStorage sem ele; toda leitura olha os dois.
const KEY = 'token';

export function getStoredToken() {
    return localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
}

export function setStoredToken(token, remember = true) {
    // Only one copy: a token left in the other storage would outlive the choice.
    clearStoredToken();
    (remember ? localStorage : sessionStorage).setItem(KEY, token);
}

export function clearStoredToken() {
    localStorage.removeItem(KEY);
    sessionStorage.removeItem(KEY);
}
